(() => {
  if (customElements.get('experts-slider')) {
    return;
  }

  class ExpertsSlider extends HTMLElement {
    constructor() {
      super();
      this.quotesSliderOptions = {
        navigation: {
          nextEl: this.querySelector('[data-controls-next]'),
          prevEl: this.querySelector('[data-controls-prev]'),
        },
        watchSlidesProgress: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        allowTouchMove: false,
        autoHeight: true,
        breakpoints: {
          990: {
            autoHeight: true,
          },
        },
      };
      this.imageSliderOptions = {
        speed: 400,
        effect: 'fade',
        autoHeight: true,
        fadeEffect: {
          crossFade: true,
        },
      };
    }

    connectedCallback() {
      this.imageSliderElement = this.querySelector('[data-images-slider]');
      this.quotesSliderElement = this.querySelector('[data-quotes-slider]');
      this.initSlider();
    }

    initSlider() {
      if (!this.imageSliderElement || !this.quotesSliderElement) return;

      this.imageSlider = new Swiper(
        this.imageSliderElement,
        this.imageSliderOptions,
      );
      this.quotesSlider = new Swiper(
        this.quotesSliderElement,
        this.quotesSliderOptions,
      );

      this.quotesSlider.controller.control = this.imageSlider;
      this.imageSlider.controller.control = this.quotesSlider;
    }
  }

  customElements.define('experts-slider', ExpertsSlider);
})();
